// extracted by css-extract-rspack-plugin
export default {"jibbleAccountConfirmation":"jibbleAccountConfirmation-j4FLV_","backButton":"backButton-mjSK0H","proceedButton":"proceedButton-gh89aX"};